import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import {
  ButtonWrapper,
  CancelButton,
  DialogHeader,
  DialogHeading,
  SaveButton,
} from '../Episode/Episode.Styled';
import Dialog from '@mui/material/Dialog';
import FormInputText from '../common/Forms/FormTextField';
import Grid from '@mui/material/Grid';
import { useForm } from 'react-hook-form';
import FormInputDropdown from '../common/Forms/FormDropdown';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCheckAdm,
  setD1TmtTmtStsId,
  setD2TmtTmtStsId,
  setD3TmtTmtStsId,
  setD4TmtTmtStsId,
  setD5TmtTmtStsId,
  setD6TmtTmtStsId,
  setD7TmtTmtStsId,
  setFaceTimei1,
  setFaceTimei2,
  setFaceTimei3,
  setFaceTimei4,
  setFaceTimei5,
  setFaceTimei6,
  setFaceTimei7,
  setG1TmtTmtStsId,
  setG2TmtTmtStsId,
  setG3TmtTmtStsId,
  setG4TmtTmtStsId,
  setG5TmtTmtStsId,
  setG6TmtTmtStsId,
  setG7TmtTmtStsId,
  setI1TmtFaceHours,
  setI1TmtTmtStsId,
  setI2TmtTmtStsId,
  setI3TmtTmtStsId,
  setI4TmtTmtStsId,
  setI5TmtTmtStsId,
  setI6TmtTmtStsId,
  setI7TmtTmtStsId,
  setIntMed,
  setIntMedId,
  setIntMedValueId,
  setIsCallVerifyPopup,
  setIsDropDownCall,
  setIsStatusTag,
  setIsTmtStsId,
  setIsValidateP3,
  setSupplementalTimei1,
  setSupplementalTimei2,
  setSupplementalTimei3,
  setSupplementalTimei4,
  setSupplementalTimei5,
  setSupplementalTimei6,
  setSupplementalTimei7,
  setVerEpdId,
  setVerIcnCDC,
  setVerPrtId,
  setVerSapAthId,
  setVerSapAthMaxUnits,
} from '../../redux/verification/verificationDialogPopupData';
import { _setVerSapAthMaxWkUnits } from '../../redux/verification/verificationActions';
import {
  getStopApi,
  postStopApi,
  setStopApi,
} from '../../services/StopApi/StopApi';
import {
  admitOrGroup,
  formDateFormat,
  groupValue,
  individualOrRes,
  medicalValue,
  missedValue,
  VERIFICATION_BASE_URL,
} from '../../constants';
import FormSuccess from '../common/Forms/FormSuccess';
import moment from 'moment';
import VarificationPopUp from '../common/VarificationPopup/VarificationPopup';
import { VerificationDialogLoadingBox, VerifyWeekTypo } from '../ui/styled';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import { generatePayloadForSave } from './utils/utilsNew';
import useTreatmentStatusDropdown from './hooks/useTreatmentStatusDropdown';
import useVerificationData from './hooks/useVerificationData';
import useVerificationValidation from './hooks/useVerificationValidation';
import VerificationDayColumn from './components/VerificationDayColumn';
import { WEEK_DAYS } from './utils/verificationConstants';
import { addDays } from './utils/verificationHelpers';

/**
 * VerificationDialog Component
 *
 * Main dialog component for verifying weekly treatment data. Displays a week view
 * (Monday-Sunday) with individual, group, and discharge treatment options for each day.
 *
 * Features:
 * - Dynamic dropdown filtering based on treatment status selection
 * - Discharge on any day disables all subsequent days
 * - Same-day treatment validation (prevents individual + group on same day)
 * - Unit count validation (week max, individual max, group max)
 * - P1/P2/P3 validation workflows
 * - Redux state management for form data
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether dialog is open
 * @param {Function} props.setOpen - Function to control dialog open state
 * @param {string} props.authToken - Authorization token for API calls
 * @param {Object} props.verifyModelList - Verification model list data
 * @param {Date|string} props.monday - Monday date of the week being verified
 * @param {string} props.month - Month identifier
 * @param {Function} props.fetchVerify - Function to refresh verification data
 * @param {Function} props.FetchDropDown - Function to fetch dropdown data
 * @param {boolean} props.openBackdrop - Whether to show loading backdrop
 * @param {Function} props.setIntMed - Function to set internal medical state
 * @param {number} props.intMed - Internal medical state value
 * @param {boolean} props.checkAdmValue - Check admission value flag
 * @param {Function} props.setCheckAdmValue - Function to set check admission value
 * @param {Function} props.setLatestUpdateField - Function to set latest updated field
 * @param {string} props.latestUpdateField - Latest updated field name
 * @param {boolean} props.canDisplayGroup - Whether group treatment can be displayed
 * @param {Function} props.setLatestTmtStsId - Function to set latest treatment status ID
 * @param {number} props.latestTmtStsId - Latest treatment status ID
 * @param {Object} props.user - Current user object
 *
 * @returns {JSX.Element} VerificationDialog component
 *
 * @example
 * <VerificationDialog
 *   open={isOpen}
 *   setOpen={setIsOpen}
 *   authToken={token}
 *   monday="2024-01-15"
 *   canDisplayGroup={true}
 *   fetchVerify={refreshData}
 * />
 */
const VerificationDialog = (props) => {
  const dispatch = useDispatch();

  const [isLoad, setIsLoad] = useState(false);

  const INDIVIDUAL_TYPE = 'I';
  const GROUP_TYPE = 'G';
  const DISCHARGE_TYPE = 'D';
  const athMaxWkUnits =
    'You have exceeded the Maximum allowable units per week for this Authorization.';
  const athMaxIndUnits =
    'You have exceeded the Maximum allowable Individual treatments per week.';
  const athMaxGrpUnits =
    'You have exceeded the Maximum allowable Group treatments per week.';
  const verification = 'Save Success.';
  const IndOrGrp = 'Day';
  const Discharge = 'Dch';
  const sameTreatment =
    'Treatments were not accepted because the participant cannot have both Individual and a Group treatment on the same day.';
  const [varificationPopUp, setVarificationPopUp] = useState(false);
  const [varificationMessage, setVarificationMessage] = useState('');
  const [isLatestVerificationDate, setIsLatestVerificationDate] = useState('');
  const [latestUpdateTag, setLatestUpdateTag] = useState('');
  const [latestStatusId, setLatestStatusId] = useState('');
  const [latestStatusType, setLatestStatusType] = useState('');
  const {
    open,
    setOpen,
    authToken,
    verifyModelList,
    monday,
    month,
    fetchVerify,
    FetchDropDown,
    openBackdrop,
    setIntMed,
    intMed,
    checkAdmValue,
    setCheckAdmValue,
    setLatestUpdateField,
    latestUpdateField,
    canDisplayGroup,
    setLatestTmtStsId,
    latestTmtStsId,
    user
  } = props;

  let tmtStsId = '';
  let tmtStsType = '';
  let intMaxWeek = 0;
  let intMaxIndWeek = 0;
  let intMaxGrpWeek = 0;

  // Use consolidated data hook - replaces 30+ useSelector calls
  const {
    verifyMasterReferenceData,
    verificationIndividual1,
    verificationIndividual2,
    verificationIndividual3,
    verificationIndividual4,
    verificationIndividual5,
    verificationIndividual6,
    verificationIndividual7,
    verificationGroup1,
    verificationGroup2,
    verificationGroup3,
    verificationGroup4,
    verificationGroup5,
    verificationGroup6,
    verificationGroup7,
    verificationDischarge1,
    verificationDischarge2,
    verificationDischarge3,
    verificationDischarge4,
    verificationDischarge5,
    verificationDischarge6,
    verificationDischarge7,
    verificationDialogPopup,
  } = useVerificationData();

  // Use consistent naming for compatibility
  const verificationIndividual1ReferenceData = verificationIndividual1;
  const verificationIndividual2ReferenceData = verificationIndividual2;
  const verificationIndividual3ReferenceData = verificationIndividual3;
  const verificationIndividual4ReferenceData = verificationIndividual4;
  const verificationIndividual5ReferenceData = verificationIndividual5;
  const verificationIndividual6ReferenceData = verificationIndividual6;
  const verificationIndividual7ReferenceData = verificationIndividual7;
  const verificationGroup1ReferenceData = verificationGroup1;
  const verificationGroup2ReferenceData = verificationGroup2;
  const verificationGroup3ReferenceData = verificationGroup3;
  const verificationGroup4ReferenceData = verificationGroup4;
  const verificationGroup5ReferenceData = verificationGroup5;
  const verificationGroup6ReferenceData = verificationGroup6;
  const verificationGroup7ReferenceData = verificationGroup7;
  const verificationDischarge1Reasons = verificationDischarge1;
  const verificationDischarge2Reasons = verificationDischarge2;
  const verificationDischarge3Reasons = verificationDischarge3;
  const verificationDischarge4Reasons = verificationDischarge4;
  const verificationDischarge5Reasons = verificationDischarge5;
  const verificationDischarge6Reasons = verificationDischarge6;
  const verificationDischarge7Reasons = verificationDischarge7;
  const VerificationDialogPopup = verificationDialogPopup;

  // Use consolidated validation hook - replaces validateP1, validateP2, validateP3
  const {
    validateP1,
    validateP2,
    validateP3,
    validateSameDayTreatment,
    validateAll,
    isValidating,
  } = useVerificationValidation({
    verificationState: VerificationDialogPopup,
    authToken,
    setVarificationPopUp,
    setVarificationMessage,
    monday,
    sunday: addDays(monday, 6),
  });
  const newWeekDate = new Date(monday).setDate(new Date(monday).getDate());
  const tuesday = new Date(monday).setDate(new Date(monday).getDate() + 2);
  const wednesday = new Date(monday).setDate(new Date(monday).getDate() + 3);
  const thursday = new Date(monday).setDate(new Date(monday).getDate() + 4);
  const friday = new Date(monday).setDate(new Date(monday).getDate() + 5);
  const saturday = new Date(monday).setDate(new Date(monday).getDate() + 6);
  const sunday = new Date(monday).setDate(new Date(monday).getDate() + 7);
  const [stop1HoursEdit, setStop1HoursEdit] = useState('');
  const [stop2HoursEdit, setStop2HoursEdit] = useState('');
  const [stop3HoursEdit, setStop3HoursEdit] = useState('');
  const [stop4HoursEdit, setStop4HoursEdit] = useState('');
  const [stop5HoursEdit, setStop5HoursEdit] = useState('');
  const [stop6HoursEdit, setStop6HoursEdit] = useState('');
  const [stop7HoursEdit, setStop7HoursEdit] = useState('');
  const {
    stop1Hours,
    stop2Hours,
    stop3Hours,
    stop4Hours,
    stop5Hours,
    stop6Hours,
    stop7Hours,
    verPrtId,
    verIcnCDC,
    verEpdId,
    verPrtKey,
    verSapAthId,
    verSapAthMaxUnits,
    verSapAthMaxWkUnits,
    i1TmtTmtStsId,
    i2TmtTmtStsId,
    i3TmtTmtStsId,
    i4TmtTmtStsId,
    i5TmtTmtStsId,
    i6TmtTmtStsId,
    i7TmtTmtStsId,
    g1TmtTmtStsId,
    g2TmtTmtStsId,
    g3TmtTmtStsId,
    g4TmtTmtStsId,
    g5TmtTmtStsId,
    g6TmtTmtStsId,
    g7TmtTmtStsId,
    d1TmtTmtStsId,
    d2TmtTmtStsId,
    d3TmtTmtStsId,
    d4TmtTmtStsId,
    d5TmtTmtStsId,
    d6TmtTmtStsId,
    d7TmtTmtStsId,
    i1TmtFaceHours,
    i2TmtFaceHours,
    i3TmtFaceHours,
    i4TmtFaceHours,
    i5TmtFaceHours,
    i6TmtFaceHours,
    i7TmtFaceHours,
    i1TmtFaceMins,
    i2TmtFaceMins,
    i3TmtFaceMins,
    i4TmtFaceMins,
    i5TmtFaceMins,
    i6TmtFaceMins,
    i7TmtFaceMins,
    i1TmtSuppHours,
    i2TmtSuppHours,
    i3TmtSuppHours,
    i4TmtSuppHours,
    i5TmtSuppHours,
    i6TmtSuppHours,
    i7TmtSuppHours,
    i1TmtSuppMins,
    i2TmtSuppMins,
    i3TmtSuppMins,
    i4TmtSuppMins,
    i5TmtSuppMins,
    i6TmtSuppMins,
    i7TmtSuppMins,
  } = VerificationDialogPopup;

  const faceTimei1Data = `${i1TmtFaceHours}:${i1TmtFaceMins}`;

  const defaultValue = {
    stop1Hours: stop1Hours,
    stop2Hours: stop2Hours,
    stop3Hours: stop3Hours,
    stop4Hours: stop4Hours,
    stop5Hours: stop5Hours,
    stop6Hours: stop6Hours,
    stop7Hours: stop7Hours,
    verPrtId: verPrtId,
    verIcnCDC: verIcnCDC,
    verPrtKey: verPrtKey,
    verEpdId: verEpdId,
    verSapAthId: verSapAthId,
    verSapAthMaxUnits: verSapAthMaxUnits,
    verSapAthMaxWkUnits: verSapAthMaxWkUnits,
    i1TmtTmtStsId: i1TmtTmtStsId,
    i2TmtTmtStsId: i2TmtTmtStsId,
    i3TmtTmtStsId: i3TmtTmtStsId,
    i4TmtTmtStsId: i4TmtTmtStsId,
    i5TmtTmtStsId: i5TmtTmtStsId,
    i6TmtTmtStsId: i6TmtTmtStsId,
    i7TmtTmtStsId: i7TmtTmtStsId,
    g1TmtTmtStsId: g1TmtTmtStsId,
    g2TmtTmtStsId: g2TmtTmtStsId,
    g3TmtTmtStsId: g3TmtTmtStsId,
    g4TmtTmtStsId: g4TmtTmtStsId,
    g5TmtTmtStsId: g5TmtTmtStsId,
    g6TmtTmtStsId: g6TmtTmtStsId,
    g7TmtTmtStsId: g7TmtTmtStsId,
    d1TmtTmtStsId: d1TmtTmtStsId,
    d2TmtTmtStsId: d2TmtTmtStsId,
    d3TmtTmtStsId: d3TmtTmtStsId,
    d4TmtTmtStsId: d4TmtTmtStsId,
    d5TmtTmtStsId: d5TmtTmtStsId,
    d6TmtTmtStsId: d6TmtTmtStsId,
    d7TmtTmtStsId: d7TmtTmtStsId,
    faceTimei1: faceTimei1Data,
    faceTimei2: `${i2TmtFaceHours}:${i2TmtFaceMins}`,
    faceTimei3: `${i3TmtFaceHours}:${i3TmtFaceMins}`,
    faceTimei4: `${i4TmtFaceHours}:${i4TmtFaceMins}`,
    faceTimei5: `${i5TmtFaceHours}:${i5TmtFaceMins}`,
    faceTimei6: `${i6TmtFaceHours}:${i6TmtFaceMins}`,
    faceTimei7: `${i7TmtFaceHours}:${i7TmtFaceMins}`,
    supplementalTimei1: `${i1TmtSuppHours}:${i1TmtSuppMins}`,
    supplementalTimei2: `${i2TmtSuppHours}:${i2TmtSuppMins}`,
    supplementalTimei3: `${i3TmtSuppHours}:${i3TmtSuppMins}`,
    supplementalTimei4: `${i4TmtSuppHours}:${i4TmtSuppMins}`,
    supplementalTimei5: `${i5TmtSuppHours}:${i5TmtSuppMins}`,
    supplementalTimei6: `${i6TmtSuppHours}:${i6TmtSuppMins}`,
    supplementalTimei7: `${i7TmtSuppHours}:${i7TmtSuppMins}`,
    isTmtStsId: VerificationDialogPopup?.isTmtStsId,
    intMedId: VerificationDialogPopup?.intMedId,
    latestTmtStsId: latestTmtStsId,
    //isDropDownCall: VerificationDialogPopup?.isDropDownCall,
  };
  const useFunction = useForm({
    defaultValues: defaultValue,
  });
  const { handleSubmit, reset, control, setValue, watch, register, formState } =
    useFunction;

  useEffect(() => {
    reset(defaultValue);
    if (VerificationDialogPopup?.isValidateP3Call === true) {
      if (latestStatusId != 0 && latestUpdateField) {
        validateP3(latestUpdateField);
        FetchDropDown();
      }
    }
  }, [
    defaultValue.stop1Hours,
    defaultValue.stop2Hours,
    defaultValue.stop3Hours,
    defaultValue.stop4Hours,
    defaultValue.stop5Hours,
    defaultValue.stop6Hours,
    defaultValue.stop7Hours,
    defaultValue.verPrtId,
    defaultValue.verPrtKey,
    defaultValue.verIcnCDC,
    defaultValue.verEpdId,
    defaultValue.verSapAthId,
    defaultValue.verSapAthMaxUnits,
    defaultValue.verSapAthMaxWkUnits,
    defaultValue.i1TmtTmtStsId,
    defaultValue.i2TmtTmtStsId,
    defaultValue.i3TmtTmtStsId,
    defaultValue.i4TmtTmtStsId,
    defaultValue.i5TmtTmtStsId,
    defaultValue.i6TmtTmtStsId,
    defaultValue.i7TmtTmtStsId,
    defaultValue.g1TmtTmtStsId,
    defaultValue.g2TmtTmtStsId,
    defaultValue.g3TmtTmtStsId,
    defaultValue.g4TmtTmtStsId,
    defaultValue.g5TmtTmtStsId,
    defaultValue.g6TmtTmtStsId,
    defaultValue.g7TmtTmtStsId,
    defaultValue.d1TmtTmtStsId,
    defaultValue.d2TmtTmtStsId,
    defaultValue.d3TmtTmtStsId,
    defaultValue.d4TmtTmtStsId,
    defaultValue.d5TmtTmtStsId,
    defaultValue.d6TmtTmtStsId,
    defaultValue.d7TmtTmtStsId,
    defaultValue.faceTimei1,
    defaultValue.faceTimei2,
    defaultValue.faceTimei3,
    defaultValue.faceTimei4,
    defaultValue.faceTimei5,
    defaultValue.faceTimei6,
    defaultValue.faceTimei7,
    defaultValue.supplementalTimei1,
    defaultValue.supplementalTimei2,
    defaultValue.supplementalTimei3,
    defaultValue.supplementalTimei4,
    defaultValue.supplementalTimei5,
    defaultValue.supplementalTimei6,
    defaultValue.supplementalTimei7,
    defaultValue.isTmtStsId,
    defaultValue.intMedId,
    // defaultValue.isDropDownCall,
    //latestStatusType,
    defaultValue.latestTmtStsId,
  ]);

  useEffect(() => {
    if (isLoad) {
      setTimeout(() => {
        setIsLoad(false);
      }, 2300);
    }
  }, [isLoad]);

  /**
   * Handles closing the verification dialog
   * Resets form state and clears Redux state
   */
  const handleClose = () => {
    reset(defaultValue);
    setIntMed(0);
    setCheckAdmValue(false);
    setLatestUpdateField('');
    setLatestTmtStsId(0);
    dispatch(setIntMedId(undefined));
    dispatch(setIsTmtStsId(undefined));
    dispatch(setIsStatusTag(''));
    setOpen(false);
  };

  // Validation functions now provided by useVerificationValidation hook
  // validateP1, validateP2, validateP3 are available from the hook above

  const FetchVerificationTreatment = async () => {
    const commonParams = `${VERIFICATION_BASE_URL}/treatmetInfo/`;
    const authorization = authToken;
    getStopApi({
      commonParams,
      authorization,
    }).then((response) => {
      // Response logged for debugging
    }).catch((e) => alert(e));
  };

  /**
   * Handles form submission for verification data
   *
   * Validates same-day treatment conflicts, generates payload, and submits
   * verification data to the API. Shows success/error messages on completion.
   */
  const onSubmit = () => {
    const url = `${VERIFICATION_BASE_URL}/${VerificationDialogPopup?.verCboId}/${VerificationDialogPopup?.verId}`;
    const authorization = authToken;
    const payloadList = generatePayloadForSave(
      VerificationDialogPopup?.i1TmtTmtStsId,
      VerificationDialogPopup?.i2TmtTmtStsId,
      VerificationDialogPopup?.i3TmtTmtStsId,
      VerificationDialogPopup?.i4TmtTmtStsId,
      VerificationDialogPopup?.i5TmtTmtStsId,
      VerificationDialogPopup?.i6TmtTmtStsId,
      VerificationDialogPopup?.i7TmtTmtStsId,
      VerificationDialogPopup?.g1TmtTmtStsId,
      VerificationDialogPopup?.g2TmtTmtStsId,
      VerificationDialogPopup?.g3TmtTmtStsId,
      VerificationDialogPopup?.g4TmtTmtStsId,
      VerificationDialogPopup?.g5TmtTmtStsId,
      VerificationDialogPopup?.g6TmtTmtStsId,
      VerificationDialogPopup?.g7TmtTmtStsId,
      VerificationDialogPopup?.d1TmtTmtStsId,
      VerificationDialogPopup?.d2TmtTmtStsId,
      VerificationDialogPopup?.d3TmtTmtStsId,
      VerificationDialogPopup?.d4TmtTmtStsId,
      VerificationDialogPopup?.d5TmtTmtStsId,
      VerificationDialogPopup?.d6TmtTmtStsId,
      VerificationDialogPopup?.d7TmtTmtStsId,
      VerificationDialogPopup?.i1TmtFaceHours,
      VerificationDialogPopup?.i2TmtFaceHours,
      VerificationDialogPopup?.i3TmtFaceHours,
      VerificationDialogPopup?.i4TmtFaceHours,
      VerificationDialogPopup?.i5TmtFaceHours,
      VerificationDialogPopup?.i6TmtFaceHours,
      VerificationDialogPopup?.i7TmtFaceHours,
      VerificationDialogPopup?.i1TmtFaceMins,
      VerificationDialogPopup?.i2TmtFaceMins,
      VerificationDialogPopup?.i3TmtFaceMins,
      VerificationDialogPopup?.i4TmtFaceMins,
      VerificationDialogPopup?.i5TmtFaceMins,
      VerificationDialogPopup?.i6TmtFaceMins,
      VerificationDialogPopup?.i7TmtFaceMins,
      VerificationDialogPopup?.i1TmtSuppHours,
      VerificationDialogPopup?.i2TmtSuppHours,
      VerificationDialogPopup?.i3TmtSuppHours,
      VerificationDialogPopup?.i4TmtSuppHours,
      VerificationDialogPopup?.i5TmtSuppHours,
      VerificationDialogPopup?.i6TmtSuppHours,
      VerificationDialogPopup?.i7TmtSuppHours,
      VerificationDialogPopup?.i1TmtSuppMins,
      VerificationDialogPopup?.i2TmtSuppMins,
      VerificationDialogPopup?.i3TmtSuppMins,
      VerificationDialogPopup?.i4TmtSuppMins,
      VerificationDialogPopup?.i5TmtSuppMins,
      VerificationDialogPopup?.i6TmtSuppMins,
      VerificationDialogPopup?.i7TmtSuppMins,
      stop1HoursEdit,
      stop2HoursEdit,
      stop3HoursEdit,
      stop4HoursEdit,
      stop5HoursEdit,
      stop6HoursEdit,
      stop7HoursEdit
    );
    const payload = payloadList;
    if (
      (defaultValue.i1TmtTmtStsId !== null &&
        defaultValue.g1TmtTmtStsId !== null) ||
      (defaultValue.i2TmtTmtStsId !== null &&
        defaultValue.g2TmtTmtStsId !== null) ||
      (defaultValue.i3TmtTmtStsId !== null &&
        defaultValue.g3TmtTmtStsId !== null) ||
      (defaultValue.i4TmtTmtStsId !== null &&
        defaultValue.g4TmtTmtStsId !== null) ||
      (defaultValue.i5TmtTmtStsId !== null &&
        defaultValue.g5TmtTmtStsId !== null) ||
      (defaultValue.i6TmtTmtStsId !== null &&
        defaultValue.g6TmtTmtStsId !== null) ||
      (defaultValue.i7TmtTmtStsId !== null &&
        defaultValue.g7TmtTmtStsId !== null)
    ) {
      setVarificationPopUp(true);
      setVarificationMessage(sameTreatment);
      dispatch(setG1TmtTmtStsId(null));
      dispatch(setG2TmtTmtStsId(null));
      dispatch(setG3TmtTmtStsId(null));
      dispatch(setG4TmtTmtStsId(null));
      dispatch(setG5TmtTmtStsId(null));
      dispatch(setG6TmtTmtStsId(null));
      dispatch(setG7TmtTmtStsId(null));
      setOpen(true);
    } else {
      setStopApi({ url, payload, authorization }).then((response) => {
        if (response.succeeded === true) {


          const url = `${VERIFICATION_BASE_URL}/verify`;
          const authorization = authToken;
          const payload = {
            cbpId: VerificationDialogPopup?.verCboId,
            weekId: monday,
            createdBy: user?.contact?.cntId,
            sapAthId: 0,
          };
          postStopApi({ url, payload, authorization }).then((response) => {
            fetchVerify();
            //if (response.succeeded === true) {
            //  setVarificationPopUp(true);
            //  setVarificationMessage(verification);
            //}
          }).catch((e) => alert(e));



          setVarificationPopUp(true);
          setVarificationMessage(verification);
          dispatch(setIsCallVerifyPopup(true));
          //fetchVerify();
          if (VerificationDialogPopup?.isCallApi) {
            validateP1();
            validateP2();
            //for from monday to sunday and then
            //validateP3();
          }
          setLatestUpdateField('');
          setIntMed(intMed);
          setCheckAdmValue(checkAdmValue);
          setLatestTmtStsId(0);
          dispatch(setIntMedId(undefined));
          dispatch(setIsTmtStsId(undefined));
          dispatch(setIsStatusTag(''));
          setOpen(false);
        }
      }).catch((e) => alert(e));
    }
  };

  // Use dropdown filtering hook for all dropdowns
  const individual1DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i1TmtTmtStsId,
    verificationIndividual1ReferenceData,
    'I',
    VerificationDialogPopup?.i1TmtOrgInvBilledYn
  );
  const individual2DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i2TmtTmtStsId,
    verificationIndividual2ReferenceData,
    'I',
    VerificationDialogPopup?.i2TmtOrgInvBilledYn
  );
  const individual3DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i3TmtTmtStsId,
    verificationIndividual3ReferenceData,
    'I',
    VerificationDialogPopup?.i3TmtOrgInvBilledYn
  );
  const individual4DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i4TmtTmtStsId,
    verificationIndividual4ReferenceData,
    'I',
    VerificationDialogPopup?.i4TmtOrgInvBilledYn
  );
  const individual5DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i5TmtTmtStsId,
    verificationIndividual5ReferenceData,
    'I',
    VerificationDialogPopup?.i5TmtOrgInvBilledYn
  );
  const individual6DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i6TmtTmtStsId,
    verificationIndividual6ReferenceData,
    'I',
    VerificationDialogPopup?.i6TmtOrgInvBilledYn
  );
  const individual7DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.i7TmtTmtStsId,
    verificationIndividual7ReferenceData,
    'I',
    VerificationDialogPopup?.i7TmtOrgInvBilledYn
  );
  const group1DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g1TmtTmtStsId,
    verificationGroup1ReferenceData,
    'G',
    VerificationDialogPopup?.g1TmtOrgInvBilledYn
  );
  const group2DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g2TmtTmtStsId,
    verificationGroup2ReferenceData,
    'G',
    VerificationDialogPopup?.g2TmtOrgInvBilledYn
  );
  const group3DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g3TmtTmtStsId,
    verificationGroup3ReferenceData,
    'G',
    VerificationDialogPopup?.g3TmtOrgInvBilledYn
  );
  const group4DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g4TmtTmtStsId,
    verificationGroup4ReferenceData,
    'G',
    VerificationDialogPopup?.g4TmtOrgInvBilledYn
  );
  const group5DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g5TmtTmtStsId,
    verificationGroup5ReferenceData,
    'G',
    VerificationDialogPopup?.g5TmtOrgInvBilledYn
  );
  const group6DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g6TmtTmtStsId,
    verificationGroup6ReferenceData,
    'G',
    VerificationDialogPopup?.g6TmtOrgInvBilledYn
  );
  const group7DropDown = useTreatmentStatusDropdown(
    VerificationDialogPopup?.g7TmtTmtStsId,
    verificationGroup7ReferenceData,
    'G',
    VerificationDialogPopup?.g7TmtOrgInvBilledYn
  );

  // Configure day columns for array-driven rendering
  const dayColumnsConfig = [
    {
      dayIndex: 1,
      dayName: 'Monday',
      date: monday,
      individualOptions: individual1DropDown,
      groupOptions: group1DropDown,
      dischargeOptions: verificationDischarge1Reasons,
      setI: setI1TmtTmtStsId,
      setG: setG1TmtTmtStsId,
      setD: setD1TmtTmtStsId,
      isDisabled: false,
    },
    {
      dayIndex: 2,
      dayName: 'Tuesday',
      date: addDays(monday, 1),
      individualOptions: individual2DropDown,
      groupOptions: group2DropDown,
      dischargeOptions: verificationDischarge2Reasons,
      setI: setI2TmtTmtStsId,
      setG: setG2TmtTmtStsId,
      setD: setD2TmtTmtStsId,
      isDisabled: defaultValue.d1TmtTmtStsId !== null,
    },
    {
      dayIndex: 3,
      dayName: 'Wednesday',
      date: addDays(monday, 2),
      individualOptions: individual3DropDown,
      groupOptions: group3DropDown,
      dischargeOptions: verificationDischarge3Reasons,
      setI: setI3TmtTmtStsId,
      setG: setG3TmtTmtStsId,
      setD: setD3TmtTmtStsId,
      isDisabled: defaultValue.d1TmtTmtStsId !== null || defaultValue.d2TmtTmtStsId !== null,
    },
    {
      dayIndex: 4,
      dayName: 'Thursday',
      date: addDays(monday, 3),
      individualOptions: individual4DropDown,
      groupOptions: group4DropDown,
      dischargeOptions: verificationDischarge4Reasons,
      setI: setI4TmtTmtStsId,
      setG: setG4TmtTmtStsId,
      setD: setD4TmtTmtStsId,
      isDisabled:
        defaultValue.d1TmtTmtStsId !== null ||
        defaultValue.d2TmtTmtStsId !== null ||
        defaultValue.d3TmtTmtStsId !== null,
    },
    {
      dayIndex: 5,
      dayName: 'Friday',
      date: addDays(monday, 4),
      individualOptions: individual5DropDown,
      groupOptions: group5DropDown,
      dischargeOptions: verificationDischarge5Reasons,
      setI: setI5TmtTmtStsId,
      setG: setG5TmtTmtStsId,
      setD: setD5TmtTmtStsId,
      isDisabled:
        defaultValue.d1TmtTmtStsId !== null ||
        defaultValue.d2TmtTmtStsId !== null ||
        defaultValue.d3TmtTmtStsId !== null ||
        defaultValue.d4TmtTmtStsId !== null,
    },
    {
      dayIndex: 6,
      dayName: 'Saturday',
      date: addDays(monday, 5),
      individualOptions: individual6DropDown,
      groupOptions: group6DropDown,
      dischargeOptions: verificationDischarge6Reasons,
      setI: setI6TmtTmtStsId,
      setG: setG6TmtTmtStsId,
      setD: setD6TmtTmtStsId,
      isDisabled:
        defaultValue.d1TmtTmtStsId !== null ||
        defaultValue.d2TmtTmtStsId !== null ||
        defaultValue.d3TmtTmtStsId !== null ||
        defaultValue.d4TmtTmtStsId !== null ||
        defaultValue.d5TmtTmtStsId !== null,
    },
    {
      dayIndex: 7,
      dayName: 'Sunday',
      date: addDays(monday, 6),
      individualOptions: individual7DropDown,
      groupOptions: group7DropDown,
      dischargeOptions: verificationDischarge7Reasons,
      setI: setI7TmtTmtStsId,
      setG: setG7TmtTmtStsId,
      setD: setD7TmtTmtStsId,
      isDisabled:
        defaultValue.d1TmtTmtStsId !== null ||
        defaultValue.d2TmtTmtStsId !== null ||
        defaultValue.d3TmtTmtStsId !== null ||
        defaultValue.d4TmtTmtStsId !== null ||
        defaultValue.d5TmtTmtStsId !== null ||
        defaultValue.d6TmtTmtStsId !== null,
    },
  ];

  /**
   * Handles treatment status changes for any day/treatment type
   *
   * Updates local state and dispatches Redux action when a treatment status
   * dropdown value changes. Triggers validation workflow.
   *
   * @param {string} statusFieldName - Name of the field being updated (e.g., 'i1TmtTmtStsId')
   * @param {number} statusValue - New status value selected
   * @param {number} statusId - Previous status ID
   * @param {Function} statusActionHandler - Redux action to dispatch
   * @param {string} statusType - Type of treatment (I/G/D)
   * @param {string} statusTag - Tag for the status (Day/Dch)
   */
  const statusChangeHandler = (
    statusFieldName,
    statusValue,
    statusId,
    statusActionHandler,
    statusType,
    statusTag
  ) => {
    setLatestUpdateField((prevState) => statusFieldName);
    setLatestTmtStsId(statusValue);
    setLatestStatusId(statusId);
    setLatestUpdateTag(statusTag);
    setLatestStatusType((prevState) => statusType);
    dispatch(statusActionHandler(statusValue));
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 'unset',
            width: '930px',
            maxHeight: '95vh',
            '&::-webkit-scrollbar': { display: 'none' },
          },
        }}
      >
        {openBackdrop ? (
          <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackdrop}
          >
            <CircularProgress />
          </Backdrop>
        ) : (
          <>
            {isLoad ? (
              <VerificationDialogLoadingBox>
                <CircularProgress />
              </VerificationDialogLoadingBox>
            ) : (
              <>
                <DialogHeader>
                  <DialogHeading variant='h5'>
                    Verification of Treatments: {verPrtKey} - {verIcnCDC}
                  </DialogHeading>
                  <IconButton onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </DialogHeader>
                <Grid container spacing={2} style={{ padding: '10px 30px' }}>
                  <Grid item xs={12} sm={4}>
                    <FormInputText
                      name='verPrtId'
                      control={control}
                      label='PrtID'
                      disabled={true}
                      register={register('verPrtId', {
                        onChange: (e) => dispatch(setVerPrtId(e.target.value)),
                      })}
                    />
                    <FormInputText
                      name='verPrtKey'
                      control={control}
                      label='PrtKey'
                      disabled={true}
                    />
                    <FormInputText
                      name='verIcnCDC'
                      control={control}
                      label='CDC Number'
                      disabled={true}
                      register={register('verIcnCDC', {
                        onChange: (e) => dispatch(setVerIcnCDC(e.target.value)),
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormInputText
                      name='verEpdId'
                      control={control}
                      label='Epd ID'
                      disabled={true}
                      register={register('verEpdId', {
                        onChange: (e) => dispatch(setVerEpdId(e.target.value)),
                      })}
                    />
                    <FormInputText
                      name='verSapAthId'
                      control={control}
                      label='Sap Auth ID'
                      disabled={true}
                      register={register('verSapAthId', {
                        onChange: (e) =>
                          dispatch(setVerSapAthId(e.target.value)),
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormInputText
                      name='verSapAthMaxUnits'
                      control={control}
                      label='Sap Auth Total'
                      disabled={true}
                      register={register('verSapAthMaxUnits', {
                        onChange: (e) =>
                          dispatch(setVerSapAthMaxUnits(e.target.value)),
                      })}
                    />
                    <FormInputText
                      name='verSapAthMaxWkUnits'
                      control={control}
                      label='Sap Auth Max/Wk'
                      disabled={true}
                      register={register('verSapAthMaxWkUnits', {
                        onChange: (e) =>
                          dispatch(_setVerSapAthMaxWkUnits(e.target.value)),
                      })}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} style={{ padding: '10px 30px' }}>
                  {/* Array-driven day columns - replaces 920 lines of duplicate code */}
                  {dayColumnsConfig.map((dayConfig) => (
                    <VerificationDayColumn
                      key={dayConfig.dayIndex}
                      dayIndex={dayConfig.dayIndex}
                      dayName={dayConfig.dayName}
                      date={dayConfig.date}
                      control={control}
                      register={register}
                      individualOptions={dayConfig.individualOptions}
                      groupOptions={dayConfig.groupOptions}
                      dischargeOptions={dayConfig.dischargeOptions}
                      isDisabled={dayConfig.isDisabled}
                      canDisplayGroup={canDisplayGroup}
                      onStatusChange={statusChangeHandler}
                      defaultValue={defaultValue}
                      setI={dayConfig.setI}
                      setG={dayConfig.setG}
                      setD={dayConfig.setD}
                    />
                  ))}
                </Grid>
                <Grid container spacing={2} style={{ padding: '10px 40px' }}>
                  <ButtonWrapper>
                    <CancelButton variant='contained' onClick={handleClose}>
                      Cancel
                    </CancelButton>
                    <SaveButton
                      variant='contained'
                      onClick={handleSubmit(onSubmit)}
                    >
                      Save
                    </SaveButton>
                  </ButtonWrapper>
                </Grid>
              </>
            )}
          </>
        )}
      </Dialog>
      <VarificationPopUp
        open={varificationPopUp}
        setOpen={setVarificationPopUp}
        type='success'
        content={varificationMessage}
      />
      <FormSuccess
        open={false}
        setOpen={() => {}}
        type='success'
        content={verification}
      />
    </>
  );
};

export default VerificationDialog;
